// RefillBanner.jsx
import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import refillery from "../../Assets/solutions/detergent-sheets-jar.webp";
import "./RefillBanner.scss";

const RefillBanner = () => {
  return (
    <Container fluid className="refill-banner-wrapper">
      <Container>
        <Row className="align-items-stretch">
            <Col xs={12} md={4} className="d-flex">
                <Card className="refill-image-card flex-fill shadow-sm border-0">
                <Card.Img
                    variant="top"
                    src={refillery}
                    alt="Refill station jars for bulk laundry detergent sheets"
                    className="img-fluid h-100"
                    loading="lazy"
                    style={{ objectFit: "cover" }}
                />
                </Card>
            </Col>

            <Col xs={12} md={7} className="d-flex mb-4 mb-md-0">
                <Card className="refill-card flex-fill">
                <Card.Body className="d-flex flex-column justify-content-between">
                    <div>
                    <Card.Title as="h2">Refill Shop Solutions</Card.Title>
                    <Card.Text>
                        Order a bulk refill case (≈5,000 loose sheets) to stock your
                        zero-waste refill station. This case format is separate from
                        retail packaged private label MOQ. Tear at the perforations or
                        weigh by the ounce—no single-use plastic required.
                    </Card.Text>
                    </div>
                    <div>
                        <Button as={Link} className="primary-btn" to="/solution#refill">
                        Learn More
                        </Button>
                    </div>
                </Card.Body>
                </Card>
            </Col>
        </Row>

      </Container>
    </Container>
  );
};

export default RefillBanner;
